var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0399 12.9602C11.4067 14.327 13.6228 14.327 14.9896 12.9602L18.5252 9.42462C19.892 8.05779 19.892 5.84171 18.5252 4.47487C17.1583 3.10804 14.9423 3.10804 13.5754 4.47487L11.8077 6.24264",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8683 10.1316C11.5015 8.76481 9.28541 8.76481 7.91857 10.1316L4.38304 13.6672C3.0162 15.034 3.0162 17.2501 4.38304 18.6169C5.74987 19.9838 7.96595 19.9838 9.33278 18.6169L11.1006 16.8492",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreLight);
export default __webpack_public_path__ + "static/media/store-light.11b68f95213ec50d9e583a6c234cffe4.svg";
export { ForwardRef as ReactComponent };